"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyAttributeDeviceName = void 0;
var StrategyAttributeDeviceName;
(function (StrategyAttributeDeviceName) {
    StrategyAttributeDeviceName["Browser"] = "browser";
    StrategyAttributeDeviceName["Mobile"] = "mobile";
    StrategyAttributeDeviceName["Desktop"] = "desktop";
    StrategyAttributeDeviceName["Server"] = "server";
    StrategyAttributeDeviceName["Watch"] = "watch";
    StrategyAttributeDeviceName["Embedded"] = "embedded";
})(StrategyAttributeDeviceName = exports.StrategyAttributeDeviceName || (exports.StrategyAttributeDeviceName = {}));
//# sourceMappingURL=strategy-attribute-device-name.js.map